// src/components/PracticeTest/LoadMoreButton.jsx


import React from 'react';
export default function LoadMoreButton({ onClick, loading }) { 
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button className="btn-full" onClick={onClick} disabled={loading}>
          {loading ? 'Loading...' : 'Load More Data'}
        </button>
      </div>
    ); 
}